import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tagsApi from '@/features/dashboard/tags/api/tagsApi.ts';
import { tagsApiQueryKeys } from '@/features/dashboard/tags/api/tagsApi.queryKeys.ts';
import { TagWebDto } from '@/features/dashboard/tags/types/TagWebDto.ts';

export default function useUpdateTag() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, dto }: { id: string; dto: TagWebDto }) =>
      tagsApi.update(id, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tagsApiQueryKeys.all() });
      toast.success('Tag został zaktualizowany');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Nie udało się zaktualizować tagu.',
      });
    },
  });
}
